var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSectionBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 195,
  height: 134,
  viewBox: "0 0 195 134"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.35 44.08C2.93 62.11 2.47 79.92.34 97.07l188.49 36.81c5.47-34.4 6.79-70.05 3.6-106.52-.79-9.02-1.78-18.02-3.15-26.78L.38 35.28c.26 3.01.71 5.79.97 8.8"
})));
export default SvgSectionBg;